module.exports = __webpack_public_path__ + "static/img/default.9b5aac4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lead-form-preview/assets/default.png
// module id = 833
// module chunks = 1